"use client";
import { jsxs as k, jsx as r, Fragment as Re } from "react/jsx-runtime";
import { cn as Q } from "@yanolja-org/nol-design-system-kit/utils";
import { Dialog as Ge } from "@yanolja-org/nol-design-system-kit/dialog";
import { useState as B, useEffect as J, useRef as he, useCallback as N, useMemo as G, useDeferredValue as He, useId as Ve, createContext as et, useContext as tt } from "react";
import { a as oe, c as Ee, I as W } from "./server-utils-B5Fn5e3-.mjs";
import { NolBridge as Pe } from "@yanolja-org/nol-bridge";
import { KinesisTracker as re } from "@yanolja-org/ya-tracker";
import { Thumbnail as ge } from "@yanolja-org/nol-design-system-kit/thumbnail";
import { IcClock as nt, IcClose as Se, IcSearch as qe, IcProperty as ct, IcDeleteFill as Be, IcSearchPc as ot } from "@yanolja-org/nol-icons-kit";
const at = {
  placeholder: "",
  debouncingDelay: 300,
  items: [],
  serverLogMeta: {}
};
function Me({
  initialData: o,
  environment: c,
  verticalCategory: a,
  verticalSubCategory: i,
  commonHeaders: s,
  onError: e,
  disableFetch: n = !1
}) {
  const { smartDiscoveryApiUrl: t } = oe[c], [l, p] = B(o ?? at);
  return J(() => {
    o && p(o);
  }, [o]), J(() => {
    if (n || !s) return;
    const { fetchSearchHome: m } = Ee(t, s);
    (async () => {
      try {
        const h = await m({ verticalCategory: a, verticalSubCategory: i });
        p(h);
      } catch (h) {
        e == null || e(h);
      }
    })();
  }, [n, s, e, t, a, i]), l;
}
function xe({ skip: o = !1 } = {}) {
  const [c, a] = B(
    o || !Pe.isEnabled ? {} : void 0
  );
  return J(() => {
    (async () => {
      if (!(o || !Pe.isEnabled))
        try {
          const { value: s } = await Pe.nolAppInfo();
          a({
            platform: s["Nol-Platform"],
            "cognito-id": s.cgntId ?? ""
          });
        } catch {
          a({});
        }
    })();
  }, []), { commonHeaders: c };
}
const le = {
  VerticalTitleButtonClose: {
    /**
     * 검색창 - 칩 해제
     * # Search
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/search/common.txtpb#L35}
     * SearchHomeCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/search.proto#L48}
     */
    click({ sourcePageName: o, homeTabName: c, logMeta: a }) {
      return re.click("SEARCH", {
        clientEventId: 740,
        pageName: "PAGE_NAME_SEARCH",
        object: "close",
        objectContainer: "verticalTitle",
        objectType: "OBJECT_TYPE_BUTTON",
        eventType: "EVENT_TYPE_CLICK",
        sourcePageName: o,
        homeTabName: c,
        ...a
      });
    }
  },
  VerticalTitleTextFieldKeyword: {
    /**
     * 키워드 입력 - 검색 실행
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/search/common.txtpb#L51}
     * SearchHomeSuggestedKeywordsClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/search.proto#L74}
     */
    click({
      suggestedKeywords: o,
      homeTabName: c,
      sourcePageName: a,
      logMeta: i
    }) {
      return re.click("SEARCH", {
        clientEventId: 737,
        pageName: "PAGE_NAME_SEARCH",
        object: "keyword",
        objectContainer: "verticalTitle",
        objectType: "OBJECT_TYPE_TEXT_FIELD",
        eventType: "EVENT_TYPE_CLICK",
        suggestedKeywords: o,
        homeTabName: c,
        sourcePageName: a,
        ...i
      });
    }
  },
  VerticalTitleTextRecentKeyword: {
    /**
     * 최근 검색어 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/search/common.txtpb#L65}
     * SearchHomeCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/search.proto#L48}
     */
    click({ sourcePageName: o, homeTabName: c, logMeta: a }) {
      return re.click("SEARCH", {
        clientEventId: 738,
        pageName: "PAGE_NAME_SEARCH",
        object: "recentKeyword",
        objectContainer: "verticalTitle",
        objectType: "OBJECT_TYPE_TEXT",
        eventType: "EVENT_TYPE_CLICK",
        sourcePageName: o,
        homeTabName: c,
        ...a
      });
    }
  },
  RecentKeywordButtonDeleteAll: {
    /**
     * 검색홈 - 최근 검색어 - 클릭 - 전체삭제 - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/search/common.txtpb#L79}
     * SearchHomeCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/search.proto#L48}
     */
    click({ sourcePageName: o, homeTabName: c }) {
      return re.click("SEARCH", {
        inactive: !1,
        clientEventId: 2179,
        pageName: "PAGE_NAME_SEARCH",
        object: "deleteAll",
        objectContainer: "recentKeyword",
        objectType: "OBJECT_TYPE_BUTTON",
        eventType: "EVENT_TYPE_CLICK",
        sourcePageName: o,
        homeTabName: c
      });
    }
  },
  RecentKeywordButtonDelete: {
    /**
     * 검색홈 - 최근 검색어 - 클릭 - 삭제 - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/search/common.txtpb#L93}
     * SearchHomeCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/search.proto#L48}
     */
    click({ sourcePageName: o, homeTabName: c, logMeta: a }) {
      return re.click("SEARCH", {
        inactive: !1,
        clientEventId: 2180,
        pageName: "PAGE_NAME_SEARCH",
        object: "delete",
        objectContainer: "recentKeyword",
        objectType: "OBJECT_TYPE_BUTTON",
        eventType: "EVENT_TYPE_CLICK",
        sourcePageName: o,
        homeTabName: c,
        ...a
      });
    }
  },
  VerticalTitleTextSuggestedKeyword: {
    /**
     * 키워드 입력 - 자동완성 검색어 클릭
     * #### 날짜 및 인원 선택 bottom sheet 시작 #####
     *## 국내 / 해외 동일한 로그 ###
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/search/common.txtpb#L108}
     * SearchHomeSuggestedKeywordsClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/search.proto#L74}
     */
    click({
      suggestedKeywords: o,
      homeTabName: c,
      sourcePageName: a,
      logMeta: i
    }) {
      return re.click("SEARCH", {
        clientEventId: 739,
        pageName: "PAGE_NAME_SEARCH",
        object: "suggestedKeyword",
        objectContainer: "verticalTitle",
        objectType: "OBJECT_TYPE_TEXT",
        eventType: "EVENT_TYPE_CLICK",
        suggestedKeywords: o,
        homeTabName: c,
        sourcePageName: a,
        ...i
      });
    }
  }
}, it = {
  [W.ITEM_TYPE_USER_QUERY]: "userQuery",
  [W.ITEM_TYPE_ONSITE_MARKETING]: "onsiteMarketing",
  [W.ITEM_TYPE_PRODUCT]: "product",
  [W.ITEM_TYPE_CID]: "cidPrompt"
};
function Ye(o) {
  return o.reduce((c, a) => {
    const i = it[a.itemType];
    if (!i) return c;
    const s = a.items.map((e) => e.title).filter((e) => !!e);
    return s.length === 0 || (c[i] = s), c;
  }, {});
}
function Je(o) {
  const c = he(o);
  c.current = o;
  const a = N(
    async (l, p) => {
      await le.VerticalTitleTextSuggestedKeyword.click({
        suggestedKeywords: l,
        ...c.current,
        logMeta: {
          ...p == null ? void 0 : p.serverLogMeta
        }
      });
    },
    []
  ), i = N(async (l) => {
    await le.VerticalTitleTextRecentKeyword.click({
      ...c.current,
      logMeta: {
        ...l.serverLogMeta
      }
    });
  }, []), s = N(async (l) => {
    await le.VerticalTitleButtonClose.click({
      ...c.current,
      logMeta: {
        ...l == null ? void 0 : l.serverLogMeta
      }
    });
  }, []), e = N(
    async (l, p) => {
      await le.VerticalTitleTextFieldKeyword.click({
        suggestedKeywords: l,
        ...c.current,
        logMeta: {
          ...p == null ? void 0 : p.serverLogMeta
        }
      });
    },
    []
  ), n = N(async (l) => {
    await le.RecentKeywordButtonDelete.click({
      ...c.current,
      logMeta: {
        ...l.serverLogMeta
      }
    });
  }, []), t = N(async () => {
    await le.RecentKeywordButtonDeleteAll.click({
      ...c.current
    });
  }, []);
  return {
    onLogItemClick: a,
    onLogRecentItemClick: i,
    onLogChipRemove: s,
    onLogSubmit: e,
    onLogRecentItemDelete: n,
    onLogRecentDeleteAll: t
  };
}
var Te = function() {
  return Te = Object.assign || function(c) {
    for (var a, i = 1, s = arguments.length; i < s; i++) {
      a = arguments[i];
      for (var e in a) Object.prototype.hasOwnProperty.call(a, e) && (c[e] = a[e]);
    }
    return c;
  }, Te.apply(this, arguments);
};
function st(o, c) {
  var a = {};
  for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && c.indexOf(i) < 0 && (a[i] = o[i]);
  if (o != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, i = Object.getOwnPropertySymbols(o); s < i.length; s++)
      c.indexOf(i[s]) < 0 && Object.prototype.propertyIsEnumerable.call(o, i[s]) && (a[i[s]] = o[i[s]]);
  return a;
}
function Ue() {
  for (var o = 0, c = 0, a = arguments.length; c < a; c++) o += arguments[c].length;
  for (var i = Array(o), s = 0, c = 0; c < a; c++)
    for (var e = arguments[c], n = 0, t = e.length; n < t; n++, s++)
      i[s] = e[n];
  return i;
}
var rt = function(o, c) {
  for (var a = "", i = 0; i < c; i++)
    a += (a && ",") + "{" + i + "}";
  return "window._yaNativeCbs_8_25_2.call(" + o + "," + a + ")";
}, lt = function(o) {
  var c = "_yaNativeCbs_8_25_2";
  window[c] || (window[c] = {}), window[c].call || (window[c].call = function(i) {
    for (var s, e, n = [], t = 1; t < arguments.length; t++)
      n[t - 1] = arguments[t];
    window[c][i] ? ((e = (s = window[c])[i]) === null || e === void 0 || e.call.apply(e, Ue([s], n)), delete window[c][i]) : console.warn("Tried to call " + i + " which is undefined. Did it timed out? Arguments:", n);
  });
  var a = 0;
  return function(i, s, e, n, t) {
    a += 1;
    var l = a;
    window[c][l] && console.warn("Callback key " + l + " is already assigned. Did you create multiple instances of yaNative?");
    var p = t && setTimeout(function() {
      window[c].call(l, !1);
    }, t);
    window[c][l] = function(m) {
      for (var f = [], h = 1; h < arguments.length; h++)
        f[h - 1] = arguments[h];
      p && clearTimeout(p), e == null || e.apply(void 0, Ue([m], f));
    }, o(Te(Te({ $path: i }, s ? { $param: s } : {}), e ? { $cb: rt(l, n) } : {}));
  };
}, dt = function() {
  var o, c, a, i;
  if (!((o = window.android) === null || o === void 0) && o.action)
    return [
      "android",
      function(s) {
        setTimeout(function() {
          var e;
          try {
            (e = window.android) === null || e === void 0 || e.action(JSON.stringify(s));
          } catch (n) {
            console.warn("Failed to call native android handler:", n);
          }
        }, 15);
      }
    ];
  if (!((i = (a = (c = window.webkit) === null || c === void 0 ? void 0 : c.messageHandlers) === null || a === void 0 ? void 0 : a.observe) === null || i === void 0) && i.postMessage)
    return [
      "ios",
      function(s) {
        setTimeout(function() {
          window.webkit.messageHandlers.observe.postMessage(s);
        }, 15);
      }
    ];
};
function pt() {
  var o = dt();
  if (!o)
    return { isEnabled: !1 };
  var c = o[0], a = o[1], i, s = lt(a);
  try {
    i = {
      _dispatch: function(e, n, t, l, p) {
        this.isEnabled && s(e, n, t, l, p);
      },
      isEnabled: !0,
      enabledFor: c,
      actions: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/actions", e, n, 1, t);
      },
      // common
      yaInfo: function(e, n) {
        n === void 0 && (n = 5e3), this._dispatch("common/yaInfo", null, e, 2, n);
      },
      appVersion: function(e, n) {
        n === void 0 && (n = 5e3), this._dispatch("common/appVersion", null, e, 2, n);
      },
      dismiss: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/dismiss", e, n, 1, t);
      },
      kinesis: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/kinesis", e, n, 1, t);
      },
      braze: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/braze", e, n, 1, t);
      },
      brazeLogPurchase: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/brazeLogPurchase", e, n, 1, t);
      },
      deepLink: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/deepLink", e, n, 1, t);
      },
      login: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/login", e, n, 1, t);
      },
      wv: function(e, n, t) {
        t === void 0 && (t = 5e3);
        var l = e.method, p = l === void 0 ? "get" : l, m = st(e, ["method"]);
        this._dispatch("common/wv", Te({ method: p }, m), n, 1, t);
      },
      setSwipeBack: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/setSwipeBack", e, n, 1, t);
      },
      fileDownload: function(e, n, t) {
        t === void 0 && (t = 1e4), this._dispatch("common/fileDownload", e, n, 1, t);
      },
      clearStack: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/clearStack", e, n, 1, t);
      },
      brightnessMax: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/brightnessMax", e, n, 1, t);
      },
      androidBackKeyFunc: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/androidBackKeyFunc", e, n, 1, t);
      },
      useBackFunc: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/useBackFunc", e, n, 1, t);
      },
      shareContent: function(e, n, t) {
        t === void 0 && (t = 5e3), e.sendTo === "kakao" && e.data.description && (e.data.desc = e.data.description), this._dispatch("common/shareContent", e, n, 1, t);
      },
      agreementUpdate: function(e, n) {
        n === void 0 && (n = 5e3), this._dispatch("common/agreementUpdate", null, e, 1, n);
      },
      requestSync: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/requestSync", e, n, 1, t);
      },
      ga4f: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/ga4f", e, n, 1, t);
      },
      // gplace
      failReservation: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("gplace/failReservation", e, n, 1, t);
      },
      // place
      billingDetail: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("place/billingDetail", e, n, 1, t);
      },
      reservationComplete: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("place/reservationComplete", e, n, 1, t);
      },
      // member
      withdrawComplete: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("member/withdrawComplete", e, n, 1, t);
      },
      pushStatus: function(e, n) {
        n === void 0 && (n = 5e3), this._dispatch("common/pushStatus", null, e, 2, n);
      },
      requestPushAuthorization: function(e, n) {
        n === void 0 && (n = !1), this._dispatch("common/requestPushAuthorization", null, e, 2, n);
      },
      locationStatus: function(e, n) {
        n === void 0 && (n = 5e3), this._dispatch("common/locationStatus", null, e, 2, n);
      },
      requestLocationAuthorization: function(e, n) {
        n === void 0 && (n = !1), this._dispatch("common/requestLocationAuthorization", null, e, 2, n);
      },
      // pip
      requestPipMode: function(e, n) {
        n === void 0 && (n = 5e3), this._dispatch("pip/requestPipMode", null, e, 1, n);
      },
      broadcastState: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("pip/broadcastState", e, n, 1, t);
      },
      logout: function(e, n) {
        n === void 0 && (n = 5e3), this._dispatch("member/logout", null, e, 1, n);
      },
      filter: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/filter", e, n, 2, t);
      },
      setFilter: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/setFilter", e, n, 1, t);
      },
      wishListUpdate: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/wishListUpdate", e, n, 1, t);
      },
      canOpen: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/canOpen", e, n, 2, t);
      },
      flag: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/flag", e, n, 2, t);
      },
      setFlag: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/setFlag", e, n, 1, t);
      },
      keyword: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("search/keyword", e, n, 1, t);
      },
      biometricStatus: function(e, n) {
        n === void 0 && (n = 5e3), this._dispatch("common/biometricStatus", null, e, 2, n);
      },
      appleLoginResult: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("member/appleLoginResult", e, n, 1, t);
      },
      canGoBack: function(e, n) {
        n === void 0 && (n = 5e3), this._dispatch("common/canGoBack", null, e, 2, n);
      },
      getNolAccessToken: function(e, n) {
        n === void 0 && (n = 5e3), this._dispatch("member/getNolAccessToken", null, e, 2, n);
      },
      reloadWebPage: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/reloadWebPage", e, n, 1, t);
      },
      checkVital: function(e, n) {
        n === void 0 && (n = 5e3), this._dispatch("common/checkVital", null, e, 1, n);
      },
      hasSigningKeyPair: function(e, n) {
        n === void 0 && (n = 5e3), this._dispatch("signature/hasSigningKeyPair", null, e, 1, n);
      },
      signWithKeyPair: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("signature/signWithKeyPair", e, n, 2, t);
      },
      permitCamera: function(e, n) {
        n === void 0 && (n = 5e3), this._dispatch("common/permitCamera", null, e, 1, n);
      },
      iOSVisibilityChanged: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/iOSVisibilityChanged", e, n, 1, t);
      },
      setIOSKeyboardAccessoryType: function(e, n, t) {
        t === void 0 && (t = 5e3), this._dispatch("common/setIOSKeyboardAccessoryType", e, n, 1, t);
      },
      isPipRunning: function(e, n) {
        n === void 0 && (n = 5e3), this._dispatch("common/isPipRunning", null, e, 2, n);
      }
    };
  } catch {
    return {
      isEnabled: !1
    };
  }
  return i;
}
var Ce;
function ht() {
  return Ce || (Ce = pt(), Ce);
}
const ut = () => typeof window > "u", H = ut() ? {} : ht(), mt = "force-close", _t = () => `${mt}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`, ke = (o) => {
  if (H.isEnabled) {
    if (!o.app)
      return;
    H.deepLink({ link: o.app });
    return;
  }
  if (o.isNewTab) {
    window.open(o.web, _t());
    return;
  }
  location.href = o.web;
}, ft = (o) => {
  H.isEnabled ? H.wv({
    url: o,
    previousWebDismiss: 1
  }) : window.location.replace(o);
}, De = 50;
function vt({
  initialRecentItems: o = [],
  environment: c,
  searchContext: a,
  commonHeaders: i,
  initialValue: s
}) {
  const { smartDiscoveryApiUrl: e } = oe[c], { fetchAutocomplete: n } = G(
    () => Ee(e, i),
    [i, e]
  ), { verticalCategory: t, verticalSubCategory: l, localAccommodation: p, globalAccommodation: m } = a, [f, h] = B((s == null ? void 0 : s.keyword) ?? ""), [g, y] = B(), [E, v] = B(o), b = he(), [T, A] = B(!1), x = He(f), _ = N(
    async (C) => {
      try {
        const R = await n(
          {
            keyword: x,
            withoutAutocomplete: !1,
            verticalCategory: t,
            verticalSubCategory: l,
            localAccommodation: p,
            globalAccommodation: m
          },
          void 0,
          C.signal
        );
        y(R), b.current = { keyword: x, autocompleteResult: R };
      } catch (R) {
        if (y(void 0), R instanceof Error && R.name !== "AbortError") throw R;
      }
    },
    [
      x,
      n,
      m,
      p,
      t,
      l
    ]
  );
  J(() => {
    v(o);
  }, [o]), J(() => {
    const C = new AbortController();
    if (!T || !x.trim()) {
      y(void 0);
      return;
    }
    return _(C), () => C.abort();
  }, [x, T, _]);
  const u = N(
    async (C) => {
      var R;
      if ((R = b.current) != null && R.autocompleteResult && b.current.keyword === C)
        return b.current.autocompleteResult;
      try {
        return await n({
          keyword: C,
          withoutAutocomplete: !1,
          verticalCategory: t,
          verticalSubCategory: l,
          localAccommodation: p,
          globalAccommodation: m
        });
      } catch {
        throw new Error("Failed to fetch autocomplete result");
      }
    },
    [n, t, l, p, m]
  ), S = N(() => A(!0), []);
  return {
    keyword: f,
    setKeyword: h,
    autoCompleteData: g,
    recentItems: E,
    setRecentItems: v,
    fetchForSubmit: u,
    activateAutocomplete: S
  };
}
const bt = {
  keyword: "keyword",
  verticalCategory: "verticalCategory",
  verticalSubCategory: "verticalSubCategory"
};
function Qe({
  initialRecentItems: o = [],
  searchBaseUrl: c,
  searchParamConfig: a,
  onSearchAction: i,
  onError: s,
  logHandlers: e,
  environment: n,
  searchContext: t,
  commonHeaders: l,
  initialValue: p,
  searchHome: m,
  setShowEmptyKeywordPopup: f
}) {
  const h = { ...bt, ...a == null ? void 0 : a.keys }, g = (a == null ? void 0 : a.additionalRemoveKeys) ?? [], { keyword: y, setKeyword: E, autoCompleteData: v, recentItems: b, setRecentItems: T, fetchForSubmit: A, activateAutocomplete: x } = vt({
    initialRecentItems: o,
    environment: n,
    searchContext: t,
    commonHeaders: l,
    initialValue: p
  }), { verticalCategory: _, verticalSubCategory: u, localAccommodation: S, globalAccommodation: C } = t, { smartDiscoveryApiUrl: R } = oe[n], { saveKeyword: M, deleteKeyword: X, fetchSearchHome: ae } = Ee(R, l), [F, L] = B(!1), [P, D] = B(-1), [ie, ue] = B(""), j = he(null), ee = he(null), Y = G(() => {
    let d = 0;
    return v != null && v.items ? v.items.map((w) => ({
      itemType: w.itemType,
      items: w.items.map((I) => ({ ...I, itemType: w.itemType, flatIndex: d++ }))
    })) : [];
  }, [v]), K = G(() => Y.flatMap((d) => d.items), [Y]), me = G(() => y.trim() && Y.length === 0 ? "hidden" : Y.length > 0 ? "autocomplete" : b.length > 0 ? "recent" : "empty", [y, b, Y]);
  J(() => {
    if (P < 0 || !j.current) return;
    const d = j.current.querySelector('[aria-selected="true"]');
    d == null || d.scrollIntoView({ block: "nearest" });
  }, [P]), J(() => {
    if (!F) return;
    const d = (w) => {
      var I;
      j.current && !j.current.contains(w.target) && (L(!1), D(-1), (I = ee.current) == null || I.blur());
    };
    return document.addEventListener("mousedown", d), () => document.removeEventListener("mousedown", d);
  }, [F]);
  const te = N(async () => {
    var w, I;
    const d = y.trim();
    if (!d) {
      f(!0), L(!1);
      return;
    }
    i == null || i(d);
    try {
      await M({
        keyword: d,
        verticalCategory: _,
        verticalSubCategory: u,
        localAccommodation: S,
        globalAccommodation: C
      });
      const U = await A(d);
      await ((w = e == null ? void 0 : e.onLogSubmit) == null ? void 0 : w.call(e, Ye(U.items), U));
      const V = U.action;
      ke(V);
    } catch {
      const U = {
        ...v,
        serverLogMeta: { ...v == null ? void 0 : v.serverLogMeta, inputWord: d, keyword: d }
      };
      await ((I = e == null ? void 0 : e.onLogSubmit) == null ? void 0 : I.call(e, {}, U));
      const { searchParams: V } = new URL(window.location.href), Ke = new URLSearchParams({ [h.keyword]: d });
      for (const Fe of [h.verticalCategory, h.verticalSubCategory]) {
        const je = V.get(Fe);
        je && Ke.append(Fe, je);
      }
      const Oe = `${c}/s/results?${Ke.toString()}`, Ze = `yanoljamotel://wv?url=${Oe}`;
      ke({ web: Oe, app: Ze });
    }
  }, [
    A,
    y,
    i,
    M,
    c,
    _,
    u,
    S,
    C,
    e,
    v,
    h
  ]), _e = () => {
    var d;
    E(""), D(-1), (d = ee.current) == null || d.focus();
  }, fe = async (d) => {
    var I;
    d.preventDefault();
    const w = new URL(window.location.href);
    [h.verticalCategory, h.verticalSubCategory, ...g].forEach((U) => {
      w.searchParams.delete(U);
    }), await ((I = e == null ? void 0 : e.onLogChipRemove) == null ? void 0 : I.call(e, v)), window.location.replace(w.toString()), L(!1);
  }, ne = N(
    async (d) => {
      var w;
      if (d.itemType === W.ITEM_TYPE_USER_QUERY) {
        const I = d.title.trim();
        await M({
          keyword: I,
          verticalCategory: _,
          verticalSubCategory: u,
          localAccommodation: S,
          globalAccommodation: C
        });
      }
      await ((w = e == null ? void 0 : e.onLogItemClick) == null ? void 0 : w.call(e, Ye((v == null ? void 0 : v.items) ?? []), d)), ke(d.action), L(!1);
    },
    [
      e,
      M,
      _,
      u,
      S,
      C,
      v
    ]
  ), ce = N(
    async (d) => {
      var I;
      const w = d.keyword.trim();
      await M({
        keyword: w,
        verticalCategory: _,
        verticalSubCategory: u,
        localAccommodation: S,
        globalAccommodation: C
      }), await ((I = e == null ? void 0 : e.onLogRecentItemClick) == null ? void 0 : I.call(e, d)), ke(d.action), L(!1);
    },
    [M, _, u, S, C, e]
  ), ve = N(
    async (d) => {
      var U;
      const I = (d.keyword || "").trim();
      if (I) {
        try {
          await X({ keyword: I, verticalCategory: _, verticalSubCategory: u });
        } catch (V) {
          s == null || s(V, "삭제에 실패했습니다. 잠시 후 다시 시도해주세요.");
        }
        try {
          const V = await ae({ verticalCategory: _, verticalSubCategory: u });
          T(V.items);
        } catch (V) {
          s == null || s(V);
        }
        (U = e == null ? void 0 : e.onLogRecentItemDelete) == null || U.call(e, d);
      }
    },
    [X, ae, s, T, _, u, e]
  ), be = N(async () => {
    var d;
    try {
      await X({ isDeleteAll: !0 }), T([]);
    } catch (w) {
      s == null || s(w, "삭제에 실패했습니다. 잠시 후 다시 시도해주세요.");
    }
    (d = e == null ? void 0 : e.onLogRecentDeleteAll) == null || d.call(e);
  }, [X, s, T, e]), se = N(
    (d) => {
      if (d.nativeEvent.isComposing) return;
      const w = K.length > 0 ? K : b;
      switch (d.key) {
        case "ArrowDown":
          d.preventDefault(), F || L(!0), w.length > 0 && D((I) => I >= w.length - 1 ? 0 : I + 1);
          break;
        case "ArrowUp":
          d.preventDefault(), F || L(!0), w.length > 0 && D((I) => I <= 0 ? w.length - 1 : I - 1);
          break;
        case "Escape":
          d.preventDefault(), L(!1), D(-1);
          break;
        case "Enter":
          if (d.preventDefault(), d.stopPropagation(), P < 0) {
            te();
            break;
          }
          K.length > 0 ? K[P] && ne(K[P]) : b[P] && ce(b[P]);
          break;
      }
    },
    [P, K, b, ne, ce, te, F]
  ), ye = N(() => {
    var d;
    (d = e == null ? void 0 : e.onLogInputFocus) == null || d.call(e, m), L(!0), x();
  }, [e, m, x]), Le = N(
    (d) => {
      E(d.target.value.slice(0, De)), D(-1), L(!0);
    },
    [E]
  );
  return {
    /** 렌더링에 필요한 읽기 전용 상태 */
    state: {
      keyword: y,
      isPanelOpen: F,
      panelMode: me,
      activeIndex: P,
      panelGroups: Y,
      flattenedItems: K,
      recentItems: b,
      toastMessage: ie,
      setToastMessage: ue
    },
    /** 사용자 인터랙션에 반응하는 이벤트 핸들러 */
    actions: {
      handleSubmit: te,
      handleClear: _e,
      handleChipRemove: fe,
      handleItemClick: ne,
      handleRecentItemClick: ce,
      handleRecentItemDelete: ve,
      handleDeleteAll: be
    },
    /** 패널 컨테이너(최상위 div)에 spread — outside 클릭 감지용 ref 포함 */
    getRootProps: () => ({ ref: j }),
    /** input 엘리먼트에 spread — ref / value / onChange / onKeyDown / onFocus 포함 */
    getInputProps: () => ({
      ref: ee,
      onChange: Le,
      onKeyDown: se,
      onFocus: ye
    })
  };
}
const yt = "_item_13sxk_1", wt = "_active_13sxk_5", It = "_thumbnail_13sxk_9", kt = "_clockIcon_13sxk_13", Tt = "_clockIconInner_13sxk_17", gt = "_textArea_13sxk_21", Ct = "_keyword_13sxk_25", Nt = "_subtitle_13sxk_29", Rt = "_deleteBtn_13sxk_33", Et = "_deleteIcon_13sxk_37", St = "_customImg_13sxk_41", O = {
  item: yt,
  active: wt,
  thumbnail: It,
  clockIcon: kt,
  clockIconInner: Tt,
  textArea: gt,
  keyword: Ct,
  subtitle: Nt,
  deleteBtn: Rt,
  deleteIcon: Et,
  customImg: St
};
function xt({
  id: o,
  item: c,
  isKeyboardActive: a,
  onClick: i,
  onDelete: s,
  verticalCategory: e,
  tabIndex: n = -1
}) {
  return /* @__PURE__ */ k(
    "li",
    {
      "aria-label": c.keyword,
      "aria-selected": a,
      className: Q(O.item, { [O.active]: a }),
      id: o,
      onClick: i,
      role: "option",
      tabIndex: n,
      children: [
        c.icon ? /* @__PURE__ */ r(
          ge,
          {
            alt: c.keyword,
            "aria-hidden": !0,
            className: O.thumbnail,
            image: c.icon,
            imageComponent: At,
            ratio: "1_1",
            shape: "capsule",
            width: 40
          }
        ) : /* @__PURE__ */ r("span", { "aria-hidden": !0, className: O.clockIcon, children: /* @__PURE__ */ r(nt, { className: O.clockIconInner }) }),
        /* @__PURE__ */ k("div", { className: O.textArea, children: [
          /* @__PURE__ */ r("span", { className: O.keyword, children: c.keyword }),
          e && c.subtitle && /* @__PURE__ */ r("span", { className: O.subtitle, children: c.subtitle })
        ] }),
        /* @__PURE__ */ r(
          "button",
          {
            "aria-hidden": "true",
            className: O.deleteBtn,
            onClick: (t) => {
              t.stopPropagation(), s();
            },
            tabIndex: -1,
            type: "button",
            children: /* @__PURE__ */ r(Se, { "aria-hidden": !0, className: O.deleteIcon })
          }
        )
      ]
    }
  );
}
const At = ({ alt: o, src: c, onError: a }) => /* @__PURE__ */ r("img", { alt: o, "aria-hidden": !0, className: O.customImg, onError: a, src: c }), Lt = "_title_1da72_1", Pt = "_mark_1da72_5", $e = {
  title: Lt,
  mark: Pt
};
function Ae({ title: o, keyword: c }) {
  const a = G(() => {
    if (!c) return null;
    const i = c.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    return o.split(new RegExp(`(${i})`, "gi"));
  }, [o, c]);
  return !a || a.length === 1 ? /* @__PURE__ */ r("span", { className: $e.title, children: o }) : /* @__PURE__ */ r("span", { className: $e.title, children: a.map(
    (i, s) => s % 2 === 1 ? /* @__PURE__ */ r("mark", { className: $e.mark, children: i }, s) : i
  ) });
}
const $t = "_item_d3oub_1", Bt = "_active_d3oub_5", Mt = "_iconWrapper_d3oub_9", Dt = "_icon_d3oub_9", Kt = "_textArea_d3oub_17", Ot = "_subtitle_d3oub_21", de = {
  item: $t,
  active: Bt,
  iconWrapper: Mt,
  icon: Dt,
  textArea: Kt,
  subtitle: Ot
};
function Ft({
  id: o,
  item: c,
  isKeyboardActive: a,
  keyword: i = "",
  onClick: s,
  tabIndex: e = -1
}) {
  return /* @__PURE__ */ k(
    "li",
    {
      "aria-selected": a,
      className: Q(de.item, { [de.active]: a }),
      id: o,
      onClick: s,
      role: "option",
      tabIndex: e,
      children: [
        /* @__PURE__ */ r("span", { "aria-hidden": !0, className: de.iconWrapper, children: /* @__PURE__ */ r(qe, { className: de.icon }) }),
        /* @__PURE__ */ k("div", { className: de.textArea, children: [
          /* @__PURE__ */ r(Ae, { keyword: i, title: c.title }),
          c.subtitle && /* @__PURE__ */ r("span", { className: de.subtitle, children: c.subtitle })
        ] })
      ]
    }
  );
}
const jt = "_item_1f7ll_1", Yt = "_active_1f7ll_5", Ut = "_thumbnail_1f7ll_9", zt = "_textArea_1f7ll_13", Wt = "_subtitle_1f7ll_17", we = {
  item: jt,
  active: Yt,
  thumbnail: Ut,
  textArea: zt,
  subtitle: Wt
};
function Gt({ id: o, item: c, isKeyboardActive: a, keyword: i, onClick: s, tabIndex: e = -1 }) {
  return /* @__PURE__ */ k(
    "li",
    {
      "aria-selected": a,
      className: Q(we.item, { [we.active]: a }),
      id: o,
      onClick: s,
      role: "option",
      tabIndex: e,
      children: [
        /* @__PURE__ */ r(
          ge,
          {
            alt: c.title,
            "aria-hidden": !0,
            className: we.thumbnail,
            image: c.image,
            ratio: "1_1",
            shape: "roundedRectangle_8",
            width: 40
          }
        ),
        /* @__PURE__ */ k("div", { className: we.textArea, children: [
          /* @__PURE__ */ r(Ae, { keyword: i, title: c.title }),
          c.subtitle && /* @__PURE__ */ r("span", { className: we.subtitle, children: c.subtitle })
        ] })
      ]
    }
  );
}
const Vt = "_item_mhljs_1", qt = "_active_mhljs_5", Jt = "_thumbnail_mhljs_9", Qt = "_title_mhljs_13", Xt = "_imgCustom_mhljs_17", Zt = "_imgFallback_mhljs_21", pe = {
  item: Vt,
  active: qt,
  thumbnail: Jt,
  title: Qt,
  imgCustom: Xt,
  imgFallback: Zt
};
function Ht({ id: o, item: c, isKeyboardActive: a, onClick: i, tabIndex: s = -1 }) {
  return /* @__PURE__ */ k(
    "div",
    {
      "aria-selected": a,
      className: Q(pe.item, { [pe.active]: a }),
      id: o,
      onClick: i,
      role: "option",
      tabIndex: s,
      children: [
        /* @__PURE__ */ r(
          ge,
          {
            alt: c.title,
            "aria-hidden": !0,
            className: pe.thumbnail,
            image: c.image,
            imageComponent: en,
            ratio: "1_1",
            shape: "capsule",
            width: 28
          }
        ),
        /* @__PURE__ */ r("span", { className: pe.title, children: c.title })
      ]
    }
  );
}
const en = ({ alt: o, src: c, onError: a }) => c ? /* @__PURE__ */ r("img", { alt: o, "aria-hidden": !0, className: pe.imgCustom, onError: a, src: c }) : /* @__PURE__ */ r("span", { className: pe.imgFallback, children: /* @__PURE__ */ r(ct, { "aria-hidden": !0, height: 20, width: 20 }) }), tn = "_item_15gbv_1", nn = "_active_15gbv_5", cn = "_thumbnail_15gbv_9", on = "_title_15gbv_13", Ne = {
  item: tn,
  active: nn,
  thumbnail: cn,
  title: on
};
function an({ id: o, item: c, isKeyboardActive: a, keyword: i, onClick: s, tabIndex: e = -1 }) {
  return /* @__PURE__ */ k(
    "li",
    {
      "aria-selected": a,
      className: Q(Ne.item, { [Ne.active]: a }),
      id: o,
      onClick: s,
      role: "option",
      tabIndex: e,
      children: [
        /* @__PURE__ */ r(
          ge,
          {
            alt: c.title,
            "aria-hidden": !0,
            className: Ne.thumbnail,
            image: c.image,
            ratio: "1_1",
            shape: "capsule",
            width: 32
          }
        ),
        /* @__PURE__ */ r("span", { className: Ne.title, children: /* @__PURE__ */ r(Ae, { keyword: i, title: c.title }) })
      ]
    }
  );
}
const sn = "_item_1f7ll_1", rn = "_active_1f7ll_5", ln = "_thumbnail_1f7ll_9", dn = "_textArea_1f7ll_13", pn = "_subtitle_1f7ll_17", Ie = {
  item: sn,
  active: rn,
  thumbnail: ln,
  textArea: dn,
  subtitle: pn
};
function hn({ id: o, item: c, isKeyboardActive: a, keyword: i, onClick: s, tabIndex: e = -1 }) {
  return /* @__PURE__ */ k(
    "li",
    {
      "aria-selected": a,
      className: Q(Ie.item, { [Ie.active]: a }),
      id: o,
      onClick: s,
      role: "option",
      tabIndex: e,
      children: [
        /* @__PURE__ */ r(
          ge,
          {
            alt: c.title,
            "aria-hidden": !0,
            className: Ie.thumbnail,
            image: c.image,
            ratio: "1_1",
            shape: "roundedRectangle_8",
            width: 40
          }
        ),
        /* @__PURE__ */ k("div", { className: Ie.textArea, children: [
          /* @__PURE__ */ r(Ae, { keyword: i, title: c.title }),
          c.subtitle && /* @__PURE__ */ r("span", { className: Ie.subtitle, children: c.subtitle })
        ] })
      ]
    }
  );
}
const un = "_panel_1h4f2_1", mn = "_listbox_1h4f2_5", _n = "_recentHeader_1h4f2_9", fn = "_recentTitle_1h4f2_13", vn = "_deleteAllBtn_1h4f2_17", bn = "_emptyState_1h4f2_21", yn = "_emptyText_1h4f2_25", wn = "_omChipGroup_1h4f2_29", q = {
  panel: un,
  listbox: mn,
  recentHeader: _n,
  recentTitle: fn,
  deleteAllBtn: vn,
  emptyState: bn,
  emptyText: yn,
  omChipGroup: wn
}, ze = {
  recent: "최근 검색어",
  autocomplete: "자동완성 검색 결과"
};
function In({
  listBoxId: o,
  mode: c,
  recentItems: a = [],
  verticalCategory: i,
  groups: s = [],
  activeIndex: e,
  keyword: n,
  onItemClick: t,
  onRecentItemClick: l,
  onRecentItemDelete: p,
  onDeleteAll: m
}) {
  return c === "hidden" ? null : /* @__PURE__ */ k("div", { className: q.panel, children: [
    c === "empty" && /* @__PURE__ */ r(Tn, {}),
    c === "recent" && /* @__PURE__ */ k(Re, { children: [
      /* @__PURE__ */ r(kn, { onDeleteAll: m }),
      /* @__PURE__ */ r("ul", { "aria-label": ze[c], className: q.listbox, id: o, role: "listbox", children: /* @__PURE__ */ r(
        gn,
        {
          activeIndex: e,
          items: a,
          listBoxId: o,
          onItemClick: l,
          onItemDelete: p,
          verticalCategory: i
        }
      ) })
    ] }),
    c === "autocomplete" && /* @__PURE__ */ r("ul", { "aria-label": ze[c], className: q.listbox, id: o, role: "listbox", children: /* @__PURE__ */ r(
      Cn,
      {
        activeIndex: e,
        groups: s,
        keyword: n,
        listBoxId: o,
        onItemClick: t
      }
    ) })
  ] });
}
function kn({ onDeleteAll: o }) {
  return /* @__PURE__ */ k("div", { className: q.recentHeader, children: [
    /* @__PURE__ */ r("span", { className: q.recentTitle, children: "최근 검색" }),
    /* @__PURE__ */ r("button", { "aria-label": "최근 검색어 전체 삭제", className: q.deleteAllBtn, onClick: o, type: "button", children: "전체삭제" })
  ] });
}
function Tn() {
  return /* @__PURE__ */ r("div", { className: q.emptyState, role: "listbox", children: /* @__PURE__ */ r("span", { className: q.emptyText, children: "최근 검색 내역이 없어요" }) });
}
function gn({
  items: o,
  listBoxId: c,
  activeIndex: a,
  onItemClick: i,
  onItemDelete: s,
  verticalCategory: e
}) {
  return /* @__PURE__ */ r(Re, { children: o.map((n, t) => /* @__PURE__ */ r(
    xt,
    {
      id: `${c}-item-${t}`,
      isKeyboardActive: a === t,
      item: n,
      onClick: () => i(n),
      onDelete: () => s(n),
      verticalCategory: e
    },
    t
  )) });
}
function Cn({
  groups: o,
  listBoxId: c,
  activeIndex: a,
  keyword: i,
  onItemClick: s
}) {
  return /* @__PURE__ */ r(Re, { children: o.map((e, n) => e.itemType === W.ITEM_TYPE_ONSITE_MARKETING ? /* @__PURE__ */ r("li", { "aria-label": "추천 검색", className: q.omChipGroup, role: "group", children: e.items.map((t) => /* @__PURE__ */ r(
    Ht,
    {
      id: `${c}-item-${t.flatIndex}`,
      isKeyboardActive: a === t.flatIndex,
      item: t,
      onClick: () => s(t)
    },
    t.flatIndex
  )) }, n) : e.items.map((t) => {
    const l = `${c}-item-${t.flatIndex}`, p = a === t.flatIndex;
    switch (t.itemType) {
      case W.ITEM_TYPE_CID:
        return /* @__PURE__ */ r(
          an,
          {
            id: l,
            isKeyboardActive: p,
            item: t,
            keyword: i,
            onClick: () => s(t)
          },
          t.flatIndex
        );
      case W.ITEM_TYPE_PRODUCT:
        return /* @__PURE__ */ r(
          Gt,
          {
            id: l,
            isKeyboardActive: p,
            item: t,
            keyword: i,
            onClick: () => s(t)
          },
          t.flatIndex
        );
      case W.ITEM_TYPE_ARTIST:
        return /* @__PURE__ */ r(
          hn,
          {
            id: l,
            isKeyboardActive: p,
            item: t,
            keyword: i,
            onClick: () => s(t)
          },
          t.flatIndex
        );
      case W.ITEM_TYPE_USER_QUERY:
        return /* @__PURE__ */ r(
          Ft,
          {
            id: l,
            isKeyboardActive: p,
            item: t,
            keyword: i,
            onClick: () => s(t)
          },
          t.flatIndex
        );
      default:
        return null;
    }
  })) });
}
const Nn = "_form_yczly_1", Rn = "_chip_yczly_5", En = "_chipLabel_yczly_9", Sn = "_chipRemoveBtn_yczly_13", xn = "_chipRemoveIcon_yczly_17", An = "_input_yczly_21", Ln = "_actionBtn_yczly_25", Pn = "_clearIcon_yczly_29", $n = "_searchIcon_yczly_33", z = {
  form: Nn,
  chip: Rn,
  chipLabel: En,
  chipRemoveBtn: Sn,
  chipRemoveIcon: xn,
  input: An,
  actionBtn: Ln,
  clearIcon: Pn,
  searchIcon: $n
};
function Bn({
  keyword: o,
  placeholder: c = "검색어를 입력하세요",
  verticalTitle: a,
  inputRef: i,
  isPanelOpen: s,
  listBoxId: e,
  activeIndex: n,
  onChange: t,
  onKeyDown: l,
  onClear: p,
  onChipRemove: m,
  onSubmit: f,
  onFocus: h
}) {
  return /* @__PURE__ */ k(
    "form",
    {
      className: z.form,
      onSubmit: (g) => {
        g.preventDefault(), f();
      },
      role: "search",
      children: [
        a && /* @__PURE__ */ k("span", { className: z.chip, children: [
          /* @__PURE__ */ r("span", { className: z.chipLabel, children: a }),
          /* @__PURE__ */ r(
            "button",
            {
              "aria-label": `${a} 검색해제`,
              className: z.chipRemoveBtn,
              onClick: m,
              type: "button",
              children: /* @__PURE__ */ r(Se, { className: z.chipRemoveIcon })
            }
          )
        ] }),
        /* @__PURE__ */ r(
          "input",
          {
            "aria-activedescendant": n >= 0 ? `${e}-item-${n}` : "",
            "aria-autocomplete": "list",
            "aria-controls": e,
            "aria-expanded": s,
            "aria-haspopup": "listbox",
            "aria-label": "검색어 입력",
            autoComplete: "off",
            className: z.input,
            maxLength: De,
            name: "keyword",
            onChange: t,
            onFocus: h,
            onKeyDown: l,
            placeholder: c,
            ref: i,
            role: "combobox",
            value: o
          }
        ),
        o && /* @__PURE__ */ r("button", { "aria-label": "검색어 삭제", className: z.actionBtn, onClick: p, type: "button", children: /* @__PURE__ */ r(Be, { className: z.clearIcon }) }),
        /* @__PURE__ */ r("button", { "aria-label": "검색", className: z.actionBtn, type: "submit", children: /* @__PURE__ */ r(ot, { className: z.searchIcon }) })
      ]
    }
  );
}
const Mn = ({ searchHomeConfig: o, logContext: c }) => {
  const a = he(!1);
  return J(() => {
    a.current || ({
      ...c,
      logMeta: o != null && o.serverLogMeta
    }, a.current = !0);
  }, [c, o]), null;
}, Dn = "_wrapper_qst7o_1", Kn = {
  wrapper: Dn
};
function On({
  environment: o,
  initialData: c,
  verticalCategory: a,
  verticalSubCategory: i,
  onSearchAction: s,
  localAccommodation: e,
  globalAccommodation: n,
  onError: t,
  initialValue: l,
  logHandlers: p,
  logContext: m,
  className: f,
  style: h,
  disableFetch: g = !1,
  fetchHeaders: y,
  customPlaceholder: E,
  searchParamConfig: v
}) {
  var ye;
  const { searchBaseUrl: b } = oe[o], { commonHeaders: T } = xe({ skip: !!y }), A = y ?? T, [x, _] = B(!1), u = Me({
    initialData: c,
    environment: o,
    verticalCategory: a,
    verticalSubCategory: i,
    commonHeaders: A,
    onError: t,
    disableFetch: g
  }), S = E ?? u.placeholder, C = (ye = u.verticalInfo) == null ? void 0 : ye.verticalTitle, R = G(() => u.items, [u]), M = G(
    () => ({ verticalCategory: a, verticalSubCategory: i, localAccommodation: e, globalAccommodation: n }),
    [a, i, e, n]
  ), X = Je(m), { state: ae, actions: F, getRootProps: L, getInputProps: P } = Qe({
    initialRecentItems: R,
    searchBaseUrl: b,
    searchParamConfig: v,
    onSearchAction: s,
    logHandlers: { ...p, ...X },
    environment: o,
    searchContext: M,
    commonHeaders: A,
    onError: t,
    initialValue: l,
    searchHome: u,
    setShowEmptyKeywordPopup: _
  }), { keyword: D, isPanelOpen: ie, panelMode: ue, activeIndex: j, panelGroups: ee, recentItems: Y } = ae, {
    handleSubmit: K,
    handleClear: me,
    handleChipRemove: te,
    handleItemClick: _e,
    handleRecentItemClick: fe,
    handleRecentItemDelete: ne,
    handleDeleteAll: ce
  } = F, { ref: ve, ...be } = P(), se = `${Ve()}-listbox`;
  return /* @__PURE__ */ k("div", { className: Q(Kn.wrapper, f), style: h, ...L(), children: [
    /* @__PURE__ */ r(
      Bn,
      {
        activeIndex: j,
        inputRef: ve,
        isPanelOpen: ie,
        keyword: D,
        listBoxId: se,
        onChipRemove: te,
        onClear: me,
        onSubmit: K,
        placeholder: S,
        verticalTitle: C,
        ...be
      }
    ),
    ie && /* @__PURE__ */ r(
      In,
      {
        activeIndex: j,
        groups: ee,
        keyword: D,
        listBoxId: se,
        mode: ue,
        onDeleteAll: ce,
        onItemClick: _e,
        onRecentItemClick: fe,
        onRecentItemDelete: ne,
        recentItems: Y,
        verticalCategory: a
      }
    ),
    /* @__PURE__ */ r(
      Ge,
      {
        id: "no-keyword-popup",
        positiveButton: {
          text: "확인",
          onClick: () => _(!1)
        },
        show: x,
        title: "검색할 키워드를 입력해주세요",
        zIndex: 55
      }
    ),
    /* @__PURE__ */ r(Mn, { logContext: m, searchHomeConfig: u })
  ] });
}
const Fn = async (o, c) => {
  if (!H.isEnabled)
    return !1;
  const a = await new Promise((i) => {
    H.isEnabled && H.appVersion((s, e) => {
      i(s ? e : null);
    });
  });
  return a ? jn(a.version, o, a.platform, c) : !1;
}, jn = (o, c, a, i) => {
  if (!We(o) || // 버전 형식이 올바르지 않은 경우
  !We(c) || i)
    return !1;
  const [s, e, n] = o.split(".").map(Number), [t, l, p] = c.split(".").map(Number);
  return s > t || s === t && e > l || s === t && e === l && n >= p;
}, We = (o) => /^(\d+)\.(\d+)\.(\d+)$/.test(o);
function Yn({
  placeholder: o,
  searchBaseUrl: c,
  verticalTitle: a,
  category: i,
  initialValue: s,
  logHandlers: e,
  searchHome: n
}) {
  const t = (s == null ? void 0 : s.keyword) ?? "", l = (s == null ? void 0 : s.verticalCategory) ?? "", p = N(
    async (f) => {
      var y;
      f.stopPropagation();
      const h = t.trim() ? `keyword=${encodeURIComponent(t.trim())}` : "", g = `${c}/s/results${h ? `?${h}` : ""}`;
      await ((y = e == null ? void 0 : e.onLogChipRemove) == null ? void 0 : y.call(e, {
        serverLogMeta: {
          verticalCategory: l,
          inputWord: t,
          verticalTitle: a
        }
      })), ft(g);
    },
    [t, c, l, a, e]
  ), m = N(
    async (f, h) => {
      var A;
      f.stopPropagation(), await ((A = e == null ? void 0 : e.onLogInputFocus) == null ? void 0 : A.call(e, n));
      const g = new URLSearchParams(), y = H.isEnabled ? "category" : "verticalCategory", E = await Fn("9.30.5") ? i : l;
      E && g.append(y, E);
      const b = [h ? `keyword=${encodeURIComponent(h)}` : "", g.toString()].filter(Boolean).join("&"), T = `search${b ? `?${b}` : ""}`;
      ke({ app: `yanoljamotel://${T}`, web: `${c}/s/${T}` });
    },
    [i, c, l, e, n]
  );
  return {
    keyword: t,
    placeholder: o,
    verticalTitle: a,
    hasKeyword: !!t,
    hasChip: !!a,
    getRootProps: () => ({
      onClick: (f) => m(f, t),
      role: "button",
      tabIndex: 0,
      "aria-label": "검색"
    }),
    getChipRemoveProps: () => ({
      onClick: p,
      type: "button",
      role: "button",
      "aria-label": a ? `${a} 검색해제` : "검색해제"
    }),
    getClearProps: () => ({
      onClick: (f) => m(f),
      type: "button",
      "aria-label": "검색어 삭제 후 검색"
    })
  };
}
const Un = "_root_1o6in_1", zn = "_chip_1o6in_5", Wn = "_chipLabel_1o6in_9", Gn = "_chipRemoveIcon_1o6in_13", Vn = "_textArea_1o6in_17", qn = "_textInner_1o6in_21", Jn = "_keywordText_1o6in_25", Qn = "_placeholderText_1o6in_29", Xn = "_clearBtn_1o6in_33", Zn = "_clearIcon_1o6in_37", Hn = "_searchIconWrapper_1o6in_41", ec = "_searchIcon_1o6in_41", $ = {
  root: Un,
  chip: zn,
  chipLabel: Wn,
  chipRemoveIcon: Gn,
  textArea: Vn,
  textInner: qn,
  keywordText: Jn,
  placeholderText: Qn,
  clearBtn: Xn,
  clearIcon: Zn,
  searchIconWrapper: Hn,
  searchIcon: ec
};
function tc({
  environment: o,
  initialData: c,
  category: a,
  verticalSubCategory: i,
  className: s,
  style: e,
  hasSearchIcon: n,
  initialValue: t,
  logHandlers: l,
  logContext: p,
  onError: m,
  disableFetch: f = !1,
  fetchHeaders: h,
  customPlaceholder: g
}) {
  var S;
  const { searchBaseUrl: y } = oe[o], { commonHeaders: E } = xe({ skip: !!h }), b = Me({
    initialData: c,
    environment: o,
    verticalCategory: a,
    verticalSubCategory: i,
    commonHeaders: h ?? E,
    onError: m,
    disableFetch: f
  }), T = g ?? b.placeholder, A = (S = b.verticalInfo) == null ? void 0 : S.verticalTitle, _ = { ...Je(p), ...l }, u = Yn({
    searchBaseUrl: y,
    category: a,
    verticalTitle: A,
    placeholder: T,
    initialValue: t,
    logHandlers: _,
    searchHome: b
  });
  return /* @__PURE__ */ r("div", { className: s, style: e, children: /* @__PURE__ */ k("div", { className: Q($.root), ...u.getRootProps(), children: [
    u.hasChip && /* @__PURE__ */ k("button", { className: $.chip, ...u.getChipRemoveProps(), type: "button", children: [
      /* @__PURE__ */ r("span", { className: $.chipLabel, children: u.verticalTitle }),
      /* @__PURE__ */ r(Se, { "aria-hidden": "true", className: $.chipRemoveIcon })
    ] }),
    /* @__PURE__ */ r("span", { className: $.textArea, children: /* @__PURE__ */ r("span", { className: $.textInner, children: u.hasKeyword ? /* @__PURE__ */ r("span", { className: $.keywordText, children: u.keyword }) : /* @__PURE__ */ r("span", { className: $.placeholderText, children: u.placeholder }) }) }),
    u.hasKeyword && /* @__PURE__ */ r("button", { className: $.clearBtn, ...u.getClearProps(), type: "button", children: /* @__PURE__ */ r(Be, { "aria-hidden": "true", className: $.clearIcon }) }),
    n && /* @__PURE__ */ r("div", { "aria-hidden": "true", className: $.searchIconWrapper, children: /* @__PURE__ */ r(qe, { className: $.searchIcon }) })
  ] }) });
}
const nc = {
  placeholder: "",
  debouncingDelay: 300,
  items: [],
  serverLogMeta: {}
};
function gc({
  environment: o,
  verticalCategory: c,
  verticalSubCategory: a,
  onError: i,
  initialValue: s,
  logHandlers: e,
  logContext: n,
  onSearchAction: t,
  localAccommodation: l,
  globalAccommodation: p,
  hasSearchIcon: m,
  containerClassName: f,
  containerStyle: h,
  linkClassName: g,
  linkStyle: y,
  customPlaceholder: E,
  searchParamConfig: v
}) {
  const { smartDiscoveryApiUrl: b } = oe[o], [T, A] = B(nc), x = he(!1), { commonHeaders: _ } = xe(), u = N(async () => {
    const { fetchSearchHome: C } = Ee(b, _);
    try {
      const R = await C({ verticalCategory: c, verticalSubCategory: a });
      A(R);
    } catch (R) {
      i == null || i(R);
    }
  }, [_, i, b, c, a]);
  J(() => {
    !_ || x.current || (x.current = !0, u());
  }, [_, u]);
  const S = G(
    () => E ? { ...T, placeholder: E } : T,
    [T, E]
  );
  return /* @__PURE__ */ k(Re, { children: [
    /* @__PURE__ */ r(
      On,
      {
        className: f,
        fetchHeaders: _,
        disableFetch: !0,
        environment: o,
        globalAccommodation: p,
        initialData: S,
        initialValue: s,
        localAccommodation: l,
        logContext: n,
        logHandlers: e,
        onError: i,
        onSearchAction: t,
        searchParamConfig: v,
        style: h,
        verticalCategory: c,
        verticalSubCategory: a
      }
    ),
    /* @__PURE__ */ r(
      tc,
      {
        category: c,
        className: g,
        fetchHeaders: _,
        disableFetch: !0,
        environment: o,
        hasSearchIcon: m,
        initialData: S,
        initialValue: s,
        logContext: n,
        logHandlers: e,
        onError: i,
        style: y,
        verticalSubCategory: a
      }
    )
  ] });
}
const Xe = et(null), cc = Xe.Provider;
function oc() {
  const o = tt(Xe);
  if (!o)
    throw new Error("SearchHome.Bar / SearchHome.Panel 은 <SearchHome.Root> 내부에서만 사용할 수 있습니다.");
  return o;
}
const ac = "_wrapper_1atz0_1", ic = {
  wrapper: ac
};
function Cc({
  environment: o,
  initialValue: c,
  fetchHeaders: a,
  initialData: i,
  verticalCategory: s,
  verticalSubCategory: e,
  onError: n,
  disableFetch: t = !1,
  onSearchAction: l,
  localAccommodation: p,
  globalAccommodation: m,
  listBoxId: f,
  className: h,
  style: g,
  customPlaceholder: y,
  children: E
}) {
  var d;
  const { searchBaseUrl: v } = oe[o], { commonHeaders: b } = xe({ skip: !!a }), T = a ?? b, [A, x] = B(!1), _ = Me({
    initialData: i,
    environment: o,
    verticalCategory: s,
    verticalSubCategory: e,
    commonHeaders: T,
    onError: n,
    disableFetch: t
  }), u = y ?? _.placeholder, S = (d = _.verticalInfo) == null ? void 0 : d.verticalTitle, C = G(() => _.items, [_]), R = G(
    () => ({ verticalCategory: s, verticalSubCategory: e, localAccommodation: p, globalAccommodation: m }),
    [s, e, p, m]
  ), { state: M, actions: X, getRootProps: ae, getInputProps: F } = Qe({
    initialRecentItems: C,
    searchBaseUrl: v,
    onSearchAction: l,
    // TODO 공통 로그 추가   =========================
    logHandlers: {},
    environment: o,
    searchContext: R,
    commonHeaders: T,
    onError: n,
    initialValue: c,
    searchHome: _,
    setShowEmptyKeywordPopup: x
  }), { keyword: L, isPanelOpen: P, panelMode: D, activeIndex: ie, panelGroups: ue, recentItems: j } = M, {
    handleSubmit: ee,
    handleClear: Y,
    handleChipRemove: K,
    handleItemClick: me,
    handleRecentItemClick: te,
    handleRecentItemDelete: _e,
    handleDeleteAll: fe
  } = X, { ref: ne, onChange: ce, onKeyDown: ve, onFocus: be } = F(), se = `${Ve()}-listbox`, Le = {
    keyword: L,
    placeholder: u,
    verticalTitle: S,
    activeIndex: ie,
    listBoxId: f ?? se,
    inputRef: ne,
    onChange: ce,
    onKeyDown: ve,
    onFocus: be,
    onSubmit: ee,
    onClear: Y,
    onChipRemove: K,
    isPanelOpen: P,
    panelMode: D,
    panelGroups: ue,
    recentItems: j,
    verticalCategory: s,
    onItemClick: me,
    onRecentItemClick: te,
    onRecentItemDelete: _e,
    onDeleteAll: fe
  };
  return /* @__PURE__ */ k("div", { className: Q(ic.wrapper, h), style: g, ...ae(), children: [
    /* @__PURE__ */ r(cc, { value: Le, children: E }),
    /* @__PURE__ */ r(
      Ge,
      {
        id: "no-keyword-popup",
        positiveButton: {
          text: "확인",
          onClick: () => x(!1)
        },
        show: A,
        title: "검색할 키워드를 입력해주세요",
        zIndex: 55
      }
    )
  ] });
}
const sc = "_searchField_2fv8n_1", rc = "_badge_2fv8n_6", lc = "_badgeLabel_2fv8n_10", dc = "_badgeRemove_2fv8n_14", pc = "_badgeRemoveIcon_2fv8n_18", hc = "_input_2fv8n_22", uc = "_clearButton_2fv8n_27", mc = "_clearIcon_2fv8n_31", Z = {
  searchField: sc,
  badge: rc,
  badgeLabel: lc,
  badgeRemove: dc,
  badgeRemoveIcon: pc,
  input: hc,
  clearButton: uc,
  clearIcon: mc
};
function Nc() {
  const {
    keyword: o,
    placeholder: c,
    verticalTitle: a,
    activeIndex: i,
    listBoxId: s,
    inputRef: e,
    onChange: n,
    onKeyDown: t,
    onFocus: l,
    onSubmit: p,
    onClear: m,
    onChipRemove: f,
    isPanelOpen: h
  } = oc(), g = !!o;
  return /* @__PURE__ */ k(
    "form",
    {
      className: Z.searchField,
      onSubmit: (y) => {
        y.preventDefault(), p();
      },
      role: "search",
      children: [
        a && /* @__PURE__ */ k("span", { className: Z.badge, children: [
          /* @__PURE__ */ r("span", { className: Z.badgeLabel, children: a }),
          /* @__PURE__ */ r(
            "button",
            {
              "aria-label": `${a} 검색 해제`,
              className: Z.badgeRemove,
              onClick: f,
              type: "button",
              children: /* @__PURE__ */ r(Se, { "aria-hidden": !0, className: Z.badgeRemoveIcon })
            }
          )
        ] }),
        /* @__PURE__ */ r(
          "input",
          {
            "aria-activedescendant": i >= 0 && s ? `${s}-item-${i}` : void 0,
            "aria-autocomplete": "list",
            "aria-controls": s,
            "aria-expanded": h,
            "aria-haspopup": "listbox",
            "aria-label": "검색어 입력",
            autoComplete: "off",
            className: Z.input,
            maxLength: De,
            name: "keyword",
            onChange: n,
            onFocus: l,
            onKeyDown: t,
            placeholder: c,
            ref: e,
            role: "combobox",
            value: o
          }
        ),
        g && /* @__PURE__ */ r("button", { "aria-label": "검색어 삭제", className: Z.clearButton, onClick: m, type: "button", children: /* @__PURE__ */ r(Be, { "aria-hidden": !0, className: Z.clearIcon }) })
      ]
    }
  );
}
export {
  On as SearchContainer,
  Nc as SearchHomeBar,
  Cc as SearchHomeRoot,
  tc as SearchLink,
  gc as SearchWidget,
  Yn as useSearchLink
};
